import { motion } from "framer-motion";
import { Star, Quote as QuoteIcon } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { TESTIMONIALS } from "../lib/content";

export const Testimonials = () => (
  <section id="testimonials" className="relative bg-[#1a1410] py-24 sm:py-36 scroll-mt-20">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_10%,rgba(212,175,55,0.07),transparent_55%)]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <Overline>Client Results</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            Real Stories. <span className="text-gold-foil">Real Results.</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid md:grid-cols-2 gap-6 lg:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <motion.figure
            key={t.name}
            data-testid={`testimonial-${i}`}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.75, delay: (i % 2) * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group relative flex flex-col bg-zinc-950/60 border border-zinc-800/80 hover:border-amber-500/50 transition-colors duration-500 p-8 sm:p-10"
          >
            <QuoteIcon
              className="h-10 w-10 text-amber-500/30 group-hover:text-amber-500/60 transition-colors duration-500"
              fill="currentColor"
            />
            <div className="mt-5 flex gap-1">
              {Array.from({ length: 5 }).map((_, s) => (
                <Star key={s} className="h-4 w-4 text-amber-400" fill="currentColor" />
              ))}
            </div>
            <blockquote className="mt-6 flex-1 font-light text-[15px] leading-relaxed text-zinc-300">
              "{t.quote}"
            </blockquote>
            <figcaption className="mt-8 pt-6 border-t border-zinc-800 flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-gold-foil text-black font-serif font-bold text-lg">
                {t.name.split(".").pop().trim().charAt(0)}
              </span>
              <span>
                <span className="block font-serif text-lg text-white">{t.name}</span>
                <span className="block text-xs uppercase tracking-[0.18em] text-amber-500">
                  {t.location}
                </span>
              </span>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
